<div class="modal is-active" role="dialog" aria-modal="true" aria-labelledby="deactivation-blocked-title">
  <div class="modal-background" (click)="onClose()"></div>
  <div class="modal-content">
    <div class="box">
      <button
        #closeButton
        type="button"
        class="modal-close-button"
        aria-label="Cerrar"
        (click)="onClose()"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>

      <h1 id="deactivation-blocked-title" class="title">No se puede desactivar el usuario</h1>

      <span class="description">
        Elimine al usuario del <strong>Equipo de trabajo</strong> y/o <strong>Contratos en curso</strong> en estos clientes:
      </span>

      <div class="table-scroll-container">
        <table class="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Cliente</th>
              <th scope="col">Pestaña</th>
            </tr>
          </thead>
          <tbody>
            @for (client of clients; track client.id) {
              <tr>
                <td>{{ client.code ?? '—' }}</td>
                <td>
                  <a
                    [routerLink]="getClientLink(client)"
                    [queryParams]="getClientQueryParams(client)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="client-link"
                  >
                    {{ getClientName(client) }}
                  </a>
                </td>
                <td>
                  <div class="source-labels">
                    @for (source of getOrderedSources(client); track source) {
                      <span class="tag source-tag">
                        {{ getSourceLabel(source) }}
                      </span>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
